import { Component } from '@angular/core';
import { LanguageService } from '@tremaze/shared/i18n';

@Component({
  selector: 'tremaze-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(private languageService: LanguageService) {
    // LanguageService initialisiert sich automatisch im Constructor
  }
}
